module.exports = __webpack_public_path__ + "img/cp10.47079e16.jpg";